<tax-modal-header>retailPlace.delete.confirmation</tax-modal-header>

<tax-modal-content>
  <div class="token-text">
    <p translate data-qa="remove-text">retailPlace.delete.text</p>
  </div>
</tax-modal-content>

<tax-modal-footer *ngIf="retailPlaceId">
  <button
    data-qa-button="remove-retail-place"
    class="button_blue ui-kit-align-right"
    (click)="confirmation(retailPlaceId)"
    translate
  >
    button.remove
  </button>
</tax-modal-footer>
